<!--  -->
<template>
  <div class="notStart">
    <div class="placeholder-img" :class="{ full: isFullScreen }" v-if="show === 2">
      <img :src="placeImg" alt="" />
    </div>
    <div class="count-down" :class="{ full: isFullScreen }" v-if="show === 1">
      <img
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/live/live-logo.png"
        alt=""
      />
      <div class="section">
        <div class="content">
          <div class="name">距直播开始还有</div>
          <div class="box">
            <div class="time" v-if="times.d && times.d !== '00'">{{ times.d }}</div>
            <div class="dot day" v-if="times.d && times.d !== '00'">天</div>
            <div class="time" v-if="times.h !== '00'">{{ times.h }}</div>
            <div class="dot" v-if="times.h !== '00'">:</div>
            <div class="time">{{ times.m }}</div>
            <div class="dot">:</div>
            <div class="time">{{ times.s }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { timerCount, replaceHyphens } from '@/utils/tools';

export default {
  components: {},
  data() {
    return {
      times: {},
      show: 0, // 1 倒计时 2 占位图
      timers: null,
    };
  },
  props: {
    placeImg: {
      type: String,
      default: '',
    },
    startTime: {
      type: String,
      default: '',
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  watch: {},
  methods: {
    showImg() {
      this.show = 2;
    },
    showCount() {
      this.show = 1;
      this.setCountDown(this.startTime);
    },
    hide() {
      this.show = 0;
    },
    setCountDown(time) {
      const currentTime = new Date().getTime();
      const startTime = new Date(replaceHyphens(time)).getTime();
      if (startTime < currentTime) {
        return;
      }
      let temp = startTime - currentTime;
      this.times = timerCount(temp, 2);
      this.timers = setInterval(() => {
        temp -= 1000;
        if (temp > 0) {
          this.times = timerCount(temp, 2);
        } else {
          clearInterval(this.timers);
          this.show = this.placeImg ? 2 : 0;
        }
      }, 1000);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.placeholder-img.full,
.count-down.full {
  width: 75%;
}
.placeholder-img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.placeholder-img img {
  width: 100%;
  height: 100%;
}

.count-down {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.count-down > img {
  position: relative;
  top: 12px;
  display: block;
  width: 110px;
  height: 102px;
  margin: 0 auto;
}
.count-down .section {
  width: 100%;
  text-align: center;
}

.count-down .content {
  width: 576px;
  height: 214px;
  margin: 0 auto;
  background: #f7f8fc;
  border-radius: 18px;
}

.count-down .name {
  width: 100%;
  padding: 30px 0 12px 0;
  color: #ff6c02;
  font-weight: 400;
  font-size: 26px;
  line-height: 36px;
  text-align: center;
}

.count-down .box {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.count-down .time {
  width: 118px;
  height: 136px;
  color: #111;
  font-weight: normal;
  font-size: 56px;
  line-height: 116px;
  text-align: center;
  background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/live/live-time-bg.png');
  background-size: 100%;
}
.count-down .dot {
  height: 136px;
  color: #111;
  font-size: 60px;
  line-height: 106px;
}
.count-down .dot.day {
  font-size: 40px;
  line-height: 116px;
}
</style>
